// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyAfEQrBiXATvOsr3ET7UT-DKDAWqWAB7rQ",
  authDomain: "sogioyna.firebaseapp.com",
  databaseURL: "https://sogioyna-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "sogioyna",
  storageBucket: "sogioyna.firebasestorage.app",
  messagingSenderId: "263432863930",
  appId: "1:263432863930:web:a5f47e64e7d1ec86284283",
  measurementId: "G-HETCL6YKQK"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Oturum kalıcılığı
setPersistence(auth, browserLocalPersistence).catch((err) => console.error(err));

export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// Firebase Analytics Entegrasyonu
export let analytics = null;

isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
}).catch((err) => console.error("Analytics desteklenmiyor:", err));

// Özel event'leri güvenle göndermek için yardımcı fonksiyon
export function logAnalyticsEvent(eventName, eventParams = {}) {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
}